import styled from '@emotion/styled/macro';

const ChildrenWrap = styled.div`
  position: relative;
`;

export { ChildrenWrap };
